export default __webpack_public_path__ + "static/media/AggregateBackground.2a0b0f8a.png";